import { Component, inject, OnInit, signal } from '@angular/core';
import { NavSidebar } from '../nav-sidebar/nav-sidebar';
import { ISidebarNavItem } from './sidebar.interface';
import { KeycloakService } from '../../services/keycloak.service';
import { IconSvg } from '../icon-svg/icon-svg';
import { AccountService } from '../../services/account.service';
import { NotificationService } from '../../services/notification.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-sidebar',
  imports: [NavSidebar, IconSvg],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css',
})
export class Sidebar implements OnInit {
  private keycloakService = inject(KeycloakService);
  private accountService = inject(AccountService);
  private notificationService = inject(NotificationService);
  private toastService = inject(ToastService);

  protected isVerified = this.accountService.isVerified;

  protected notificationsNbr = signal(0);

  protected navItemsData: ISidebarNavItem[] = [
    {
      id: 1,
      name: 'Tableau de bord',
      iconName: 'dashboard',
      pagePath: '/tableau-de-bord'
    }, {
      id: 2,
      name: 'Statistiques',
      iconName: 'statistic',
      pagePath: '/statistiques'
    }, {
      id: 3,
      name: 'Réservations',
      iconName: 'booking',
      pagePath: '/reservations'
    }, {
      id: 4,
      name: 'Activités',
      iconName: 'activity',
      pagePath: '/activites'
    }, {
      id: 5,
      name: 'Promotions',
      iconName: 'discount',
      pagePath: '/promotions'
    }, {
      id: 6,
      name: 'Facturation',
      iconName: 'invoice',
      pagePath: '/billing'
    }, {
      id: 7,
      name: 'Avis',
      iconName: 'star',
      pagePath: '/avis'
    }, {
      id: 8,
      name: 'Notifications',
      iconName: 'notification',
      pagePath: '/notifications'
    },
  ];

  protected settingItemsData: ISidebarNavItem[] = [
    {
      id: 8,
      name: 'Paramètres',
      iconName: 'parameter',
      pagePath: '/parametre'
    }, {
      id: 9,
      name: 'Support',
      iconName: 'support',
      pagePath: '/support'
    },
  ];

  protected logout(): void {
    this.keycloakService.logout();
  }

  ngOnInit(): void {
    this.notificationService.getNotifications(['all']).subscribe({
      error: () => this.toastService.error("Erreur lors de la récupération des notifications")
    });

    this.notificationService.notifications.subscribe(notifications => {
      this.notificationsNbr.set(notifications.filter(n => !n.read).length);
    });
  }
}
